import React from "react";
import { Col, Row } from "react-bootstrap";
import { FaHtml5, FaCss3Alt, FaNodeJs, FaReact, FaGitAlt, FaGithub, FaNpm } from "react-icons/fa";


import {
  // SiFirebase,
  SiJavascript,
  SiChakraui, SiMongodb, SiRedux, SiExpress
} from "react-icons/si";
import AOS from 'aos';
import 'aos/dist/aos.css';
AOS.init();
AOS.refreshHard();



function Techstack() {
  return (
    <>
      <Row style={{ justifyContent: "center", paddingTop: "50px" }}>
        <Col xs={4} md={2} className="tech-icons">
          <FaHtml5 />
          <p style={{ fontSize: "11px" }}>HTML</p>
        </Col>

        <Col xs={4} md={2} className="tech-icons">
          <FaCss3Alt />
          <p style={{ fontSize: "11px" }}>CSS</p>
        </Col>

        <Col xs={4} md={2} className="tech-icons">
          <SiJavascript />
          <p style={{ fontSize: "11px" }}>JavaScript</p>
        </Col>

        <Col xs={4} md={2} className="tech-icons">
          <FaNodeJs />
          <p style={{ fontSize: "11px" }}>Node Js</p>
        </Col>

        <Col xs={4} md={2} className="tech-icons">
          <FaReact />
          <p style={{ fontSize: "11px" }}>React Js</p>
        </Col>

      </Row>

      <Row style={{ justifyContent: "center" }}>

        <Col xs={4} md={2} className="tech-icons">
          <FaGitAlt />
          <p style={{ fontSize: "11px" }}>Git</p>
        </Col>

        <Col xs={4} md={2} className="tech-icons">
          <FaGithub />
          <p style={{ fontSize: "11px" }}>GitHub</p>
        </Col>

        <Col xs={4} md={2} className="tech-icons">
          <SiChakraui />
          <p style={{ fontSize: "11px" }}>Chakra UI</p>
        </Col>

        <Col xs={4} md={2} className="tech-icons">
          <FaNpm />
          <p style={{ fontSize: "11px" }}>NPM</p>
        </Col>
      </Row>

      <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>

        <Col xs={4} md={2} className="tech-icons">
          <SiMongodb />
          <p style={{ fontSize: "11px" }}>Mongo DB</p>
        </Col>

        <Col xs={4} md={2} className="tech-icons">
          <SiRedux />
          <p style={{ fontSize: "11px" }}>Redux</p>
        </Col>

        <Col xs={4} md={2} className="tech-icons">
          <SiExpress />
          <p style={{ fontSize: "11px" }}>Express</p>
        </Col>

      </Row>
    </>
  );
}

export default Techstack;
